var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCafe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4986_5765",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4986_5765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16669 16.5625V15.7292H15.4584V16.5625H4.16669ZM6.66669 13.4375C5.97224 13.4375 5.38196 13.1911 4.89585 12.6983C4.40974 12.205 4.16669 11.6181 4.16669 10.9375V3.4375H15.4584C15.8195 3.4375 16.132 3.56944 16.3959 3.83333C16.6597 4.09722 16.7917 4.40972 16.7917 4.77083V6.4375C16.7917 6.8125 16.6597 7.13194 16.3959 7.39583C16.132 7.65972 15.8195 7.79167 15.4584 7.79167H14.1667V10.9375C14.1667 11.6181 13.9236 12.205 13.4375 12.6983C12.9514 13.1911 12.3611 13.4375 11.6667 13.4375H6.66669ZM6.66669 12.6042H11.6667C12.125 12.6042 12.5175 12.4408 12.8442 12.1142C13.1703 11.7881 13.3334 11.3958 13.3334 10.9375V4.27083H5.00002V10.9375C5.00002 11.3958 5.16335 11.7881 5.49002 12.1142C5.81613 12.4408 6.20835 12.6042 6.66669 12.6042ZM14.1667 6.95833H15.4584C15.5972 6.95833 15.7153 6.90972 15.8125 6.8125C15.9097 6.71528 15.9584 6.59028 15.9584 6.4375V4.77083C15.9584 4.61806 15.9097 4.49639 15.8125 4.40583C15.7153 4.31583 15.5972 4.27083 15.4584 4.27083H14.1667V6.95833Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafe);
export default __webpack_public_path__ + "static/media/Cafe.4a5ce772558bf2a94c9a5f63c99eb091.svg";
export { ForwardRef as ReactComponent };